export type TypePieceIdentite = "cni" | "passeport" | "permis" | "carte-consulaire" | "autre";

export interface Locataire {
  id: string;
  prenom: string;
  nom: string;
  telephone: string;
  /** Numéro WhatsApp (facultatif) — prépare les futures relances WhatsApp. */
  whatsapp: string;
  email: string;
  adresse: string;
  profession: string;
  typePiece: TypePieceIdentite | "";
  numeroPiece: string;
  contactUrgence: string;
  notes: string;
  /**
   * FK Supabase `proprietaire_id` (rattachement interne).
   * Champ préparé : renseigné une fois le CRUD Supabase branché (Bloc suivant).
   */
  proprietaireId?: string;
  /**
   * FK Supabase `agence_id` (rattachement interne).
   * Champ préparé : renseigné une fois le CRUD Supabase branché (Bloc suivant).
   */
  agenceId?: string;
  createdAt: string;
}

export type LocataireInput = Omit<Locataire, "id" | "createdAt">;

export const TYPE_PIECE_LABELS: Record<TypePieceIdentite, string> = {
  cni: "CNI",
  passeport: "Passeport",
  permis: "Permis de conduire",
  "carte-consulaire": "Carte consulaire",
  autre: "Autre",
};

export const TYPE_PIECE_OPTIONS = (Object.keys(TYPE_PIECE_LABELS) as TypePieceIdentite[]).map((value) => ({
  value,
  label: TYPE_PIECE_LABELS[value],
}));

export function locataireNomComplet(locataire: Locataire): string {
  return [locataire.prenom, locataire.nom].filter(Boolean).join(" ").trim() || "Locataire sans nom";
}

export function locataireInitiales(locataire: Locataire): string {
  const prenom = locataire.prenom.trim().charAt(0);
  const nom = locataire.nom.trim().charAt(0);
  return `${prenom}${nom}`.toUpperCase() || "L";
}

/**
 * Modèle de données prévu pour Supabase.
 * Table cible : `locataires`
 *   id uuid primary key default gen_random_uuid()
 *   owner_id uuid references auth.users(id)
 *   prenom text not null, nom text not null
 *   telephone text, email text, adresse text, profession text
 *   type_piece text, numero_piece text
 *   contact_urgence text, notes text
 *   created_at timestamptz default now()
 * Les contrats et biens occupés d'un locataire seront calculés via la table `contrats`.
 */